/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import NProgress from 'nprogress';
import Backbone from 'backbone';
import _ from 'lodash';

import ErrorView from '@/views/ErrorView/ErrorView';
import Scaffold from '@/Scaffold';
import * as NavUtils from '@/util/NavUtils';

import AssessmentDashboardPage from '../pages/AssessmentDashboardPage';

export default async function ShowAssessmentDashboardPage() {
  if(EXTERNAL) {
    showErrorView();
    return;
  }
  
  NProgress.start();
  try {
    NavUtils.navigate(`assessments`);
    Scaffold.getRegion('content').show(
      new AssessmentDashboardPage({
        model: new Backbone.Model({})
      })
    );
  } finally {
    NProgress.done();
  }
}

function showErrorView(err) {
  Scaffold.getRegion('content').show(
    new ErrorView({
      model: new Backbone.Model({
        errorMessage: _.isString(err?.message) ? err?.message : 'Access Denied',
        errorDetails: 'Your account may not have permission to view the Internal Assessments Search Dashboard page.'
      })
    })
  );
}